import { Action } from 'redux';

import { ExtractEncryptionState } from '../../../datasource/models/IDataSourceInfo';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { CreateExtracts } from '../AppActionTypes';

export interface CreateExtractsAction extends Action {
  selectedContent: IContentInfo[];
  encryptionState: ExtractEncryptionState;
}

export function createExtractsMethod(
  selectedContent: IContentInfo[],
  encryptionState: ExtractEncryptionState
): CreateExtractsAction {
  return {
    type: CreateExtracts,
    selectedContent,
    encryptionState
  };
}
